import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'glass' | 'solid' | 'border';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  hover?: boolean;
  centered?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  variant = 'glass',
  padding = 'md',
  hover = false,
  centered = false
}) => {
  const baseClasses = 'rounded-lg transition-all duration-300';
  
  const variantClasses = {
    glass: 'bg-white/5 backdrop-blur-md border border-white/10',
    solid: 'bg-dark-800',
    border: 'border border-white/20'
  };
  
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-12'
  };
  
  const hoverClasses = hover ? 'hover:bg-white/10 hover:border-white/20 hover:-translate-y-2' : '';
  const centerClasses = centered ? 'text-center' : '';
  
  const classes = `
    ${baseClasses}
    ${variantClasses[variant]}
    ${paddingClasses[padding]}
    ${hoverClasses}
    ${centerClasses}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Card;
